// variables
export const sliderWidth = 300;
export const brasilCountryCode = '+55';

// colors
export const black = '#2a2a2a';
export const mediumBlack = '#7d7d7d';
export const transparent = 'transparent';
export const darkBlack = '#000000';
export const lighterBlack = '#4a4a4a';
export const lightAqua = 'rgba(0, 35, 59, 0.7)';
export const acqa = '#06aaee';
export const darkAcqa = '#006598';
export const blue = '#07496f';
export const pink = '#e01a59';
export const red = '#e27b7b';
export const white = '#ffffff';
export const backgroundColor = '#eeeeee';
export const mapBackground = 'rgba(7, 73, 111, 0.75)';
export const darkGray = '#c3c3c3';
export const medGray = '#d3d3d3';
export const gray = '#e0e0e0';
export const lightGray = '#f0f0f0';
export const lightBlue = 'rgba(0, 101, 152, 0.15)';
export const darkBlue = '#00233b';
export const orange = '#ff9600';

export const lightGreen = '#84ba4d';
export const lightRed = '#d95f4f';
export const lightOrange = '#f49b0b';
export const dodgerBlue = '#518eff';
export const mineSharf = '#333333';
